import React from 'react';
import { connect } from 'react-redux';
import * as LX from '@utils/lxWrapper';
import * as Ids from '@utils/ids';
import { getCookie } from '@utiljs/cookie';
import { stringify } from '@utiljs/param';
import { RootState } from '../../../../../store';
import { IBusinessStatus } from '../../../../../api/define';
import { FRAME_NAME, getFrameByName } from '../../../../../utils/subFrames';
import styles from './StatusNotice.module.scss';

type StatusNoticeProps = {
    businessStatusInfo: IBusinessStatus;
};

const { useCallback } = React;

const StatusNotice: React.FC<StatusNoticeProps> = ({ businessStatusInfo }) => {
    /** 查看完整通知 */
    const toDeteil = useCallback(() => {
        LX.reportMC('b_waimai_e_ya38wffa_mc', 'c_waimai_e_fa4ps4ng', {
            // eslint-disable-next-line @typescript-eslint/camelcase
            is_delivery_temp_biz_hour_effective: businessStatusInfo.hasSpecialShippingTime,
        });
        let targetHref = businessStatusInfo.noticeUrl || '';
        if (targetHref.indexOf('http') === 0) {
            const params = {
                _source: 'PC',
                token: Ids.getToken(),
                acctId: Ids.getAcctId(),
                wmPoiId: Ids.getWmPoiId(),
                region_id: getCookie('region_id'),
                // eslint-disable-next-line @typescript-eslint/camelcase
                device_uuid: getCookie('device_uuid'),
                bsid: getCookie('bsid'),
                appType: 3,
                fromPoiChange: false,
            };

            const hrefParts = targetHref.split('#');
            let paramStr =
                typeof hrefParts[0] === 'string' && hrefParts[0].indexOf('?') > 0 ? '&' : '?';
            paramStr += stringify(params);
            targetHref =
                hrefParts[0] +
                paramStr +
                (hrefParts && hrefParts.length > 1 ? `#${hrefParts[1]}` : '');
        }

        const hashFrame = getFrameByName(FRAME_NAME.HASH);
        if (hashFrame) {
            hashFrame.location.href = targetHref;
        }
    }, [businessStatusInfo]);

    const { specialShippingTime, hasSpecialShippingTime, importantNotice } = businessStatusInfo;

    const specialShippingTimeList = specialShippingTime && JSON.parse(specialShippingTime);

    return (
        <>
            {hasSpecialShippingTime && specialShippingTime ? (
                <div>
                    <div className={`${styles.menuItem} ${styles.noticeItem}`}>
                        <span className={styles.importantNotice}>
                            <i />
                            重要通知
                        </span>
                    </div>
                    <div className={styles.menuItem}>
                        <p className={styles.notice}>{importantNotice}</p>
                        <p className={styles.subNotice}>配送站近期营业时间安排：</p>
                        {specialShippingTimeList.slice(0, 2).map((time: any) => {
                            const date = Object.keys(time)[0];
                            const month = Number(date.substr(4, 2));
                            const day = Number(date.substr(6, 2));
                            return (
                                <p
                                    className={styles.specialShippingTime}
                                    key={time}
                                >{`${month}月${day}日${Array.isArray(time[date]) &&
                                    time[date].join(' ')}`}</p>
                            );
                        })}
                        <div className={styles.link} onClick={toDeteil}>
                            查看完整通知
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        businessStatusInfo: state.shellHeader.poiBusinessStatus,
    };
};

export default connect(mapStateToProps)(StatusNotice);
